module.exports = __webpack_public_path__ + "static-portal/img/news13-2.ddec68e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news13-2.jpg
// module id = tzkA
// module chunks = 4